import { Resource } from './resource';
import gql from 'graphql-tag';

export class EquipmentTypeResource extends Resource {
  public static async list() {
    return await this.query(
      {
        query: gql`
          query {
            equipmentTypes {
              id
              name
              mask
              equipments {
                id
              }
            }
          }
        `
      },
      'equipmentTypes'
    );
  }

  public static async listSimple() {
    return await this.query(
      {
        query: gql`
          query {
            equipmentTypes {
              id
              name
              mask
            }
          }
        `
      },
      'equipmentTypes'
    );
  }

  public static async add(schema: any) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($name: String!, $mask: String!) {
            equipmentTypeCreate(name: $name, mask: $mask) {
              id
              name
              mask
              equipments {
                id
              }
            }
          }
        `,
        variables: { name: schema.$model.name, mask: schema.$model.mask }
      },
      'equipmentTypeCreate'
    );
  }

  public static async update(schema: any) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!, $name: String!, $mask: String!) {
            equipmentTypeUpdate(id: $id, name: $name, mask: $mask) {
              id
              name
              mask
            }
          }
        `,
        variables: { id: schema.$model.id, name: schema.$model.name, mask: schema.$model.mask }
      },
      'equipmentTypeUpdate'
    );
  }

  public static async delete(id: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!) {
            equipmentTypeDelete(id: $id)
          }
        `,
        variables: { id }
      },
      'equipmentTypeDelete'
    );
  }
}
